module.exports = __webpack_public_path__ + "static/media/beautyCosmetics.d3e5bcea.jpg";